module.exports = __webpack_public_path__ + "media/images/athletes/2126-08cb945bb1673008839ad1f81344adb8.png";